{
  "min": 140,
  "max": 1024,
  "R": [0, 2, 113, 255],
  "G": [0, 1, 109, 250],
  "B": [0, 1, 101, 245],
  "A": [0, 1, 96, 168],
  "I": [0, 1, 128, 255]
}
